import { render, staticRenderFns } from "./ProductionAuth.vue?vue&type=template&id=11bedb68&scoped=true&"
import script from "./ProductionAuth.vue?vue&type=script&lang=js&"
export * from "./ProductionAuth.vue?vue&type=script&lang=js&"
import style0 from "./ProductionAuth.vue?vue&type=style&index=0&id=11bedb68&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11bedb68",
  null
  
)

export default component.exports